<!--
Author: TangChen
Date: 2018-11-22
Desc: 修改用户信息组件
 -->
<template>
    <div class="comp-user-info comp">
        <el-row class="acct-box">
            <el-form
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                :label-width="(fn?'150':'150')+'px'"
                class="acct-form"
                :class="{'certexpdate-box':fn}"
                :disabled="acctInfo.usertype==='2'"
                v-on:submit.native.prevent
            >
                <span v-if="!fn" class="amount">机构信息</span>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="机构名称：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.custfullname }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="投资者类型：">
                        <div class="text-con">
                            {{ $cache.getDict('120051',acctInfo.professionflag) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件类型：">
                        <div class="text-con">
                            {{ $cache.getDict('130008',acctInfo.certificatetype) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件号码：" prop="certificateno">
                        <div class="text-con">
                            {{ acctInfo.certificateno_ext }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <!-- <el-form-item label="证件有效期：" prop="">
                        {{ $util.fmtDate(acctInfo.vailddate) }}
                    </el-form-item> -->
                    <el-form-item label="证件有效期：" prop="vailddate" class="required">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="邮政编码：" prop="postcode" class="required">
                        <el-input v-model.trim="acctInfo.postcode" placeholder="" :maxlength="6" />
                    </el-form-item>
                </el-col>

                <el-col v-if="!fn" :span="24">
                    <country-city-select ref="livingaddress" v-model="livingAddressObj" country-layout="user" v-on:input="getAddress"></country-city-select>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="通讯地址详细地址：" prop="address" class="required">
                        <el-input v-model.trim="acctInfo.address" placeholder="" :maxlength="64" />
                    </el-form-item>
                </el-col>
                <!--<el-col :span="12">-->
                    <!--<el-form-item label="对账单寄送周期：" prop="delivertype" class="required">-->
                        <!--<el-select-->
                            <!--v-model="acctInfo.delivertype"-->
                            <!--filterable-->
                            <!--placeholder="请选择对账单寄送周期"-->
                        <!--&gt;-->
                            <!--<el-option-->
                                <!--v-for="item in delivertypes"-->
                                <!--:key="item.subitem"-->
                                <!--:label="item.subitemname"-->
                                <!--:value="item.subitem"-->
                            <!--/>-->
                        <!--</el-select>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="电子邮箱：" prop="email">
                        <el-input v-model.trim="acctInfo.email" placeholder="请输入电子邮箱" :maxlength="64" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="传真号码：" prop="fax">
                        <el-select
                            v-model="acctInfo.faxcycode"
                            placeholder="请选择国家码"
                            style="width:150px!important"
                        >
                            <el-option

                                v-for="item in faxcycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.faxcycode == '86'"
                            v-model="acctInfo.faxareacode"
                            placeholder="请选择地区码"
                            style="width:150px!important"
                        >
                            <el-option
                                v-for="item in faxareacode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-else v-model.trim="acctInfo.faxareacodeinput" placeholder="请输入地区码" style="width:150px!important" />
                        <el-input v-model.trim="acctInfo.fax" placeholder="" :maxlength="14" style="width:240px"/>
                    </el-form-item>
                </el-col>
                <!-- <el-col v-if="!fn" :span="24">
                    <el-form-item label="实际控制人：" prop="actualctrlname" class="required">
                        <el-radio-group v-model="acctInfo.actualctrlname">
                            <el-radio
                                label="本机构"
                            />
                            <el-radio
                                label="其他"
                            />
                            <el-input
                                v-if="acctInfo.actualctrlname=='其他'"
                                v-model.trim="acctInfo.actualctrlnameText"
                                style="width:120px"
                                placeholder=""
                                :maxlength="16"
                            />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="实际受益人：" prop="beneficiary" class="required">
                        <el-radio-group v-model="acctInfo.beneficiary">
                            <el-radio
                                label="本机构"
                            />
                            <el-radio
                                label="其他"
                            />
                            <el-input
                                v-if="acctInfo.beneficiary=='其他'"
                                v-model.trim="acctInfo.beneficiaryText"
                                style="width:120px"
                                placeholder=""
                                :maxlength="16"
                            />
                        </el-radio-group>
                    </el-form-item>
                </el-col> -->

                <!--控股股东/控制人信息start-->
                <el-col v-if="!fn" style="padding-bottom:20px">
                    <div class="border"></div>
                </el-col>
                <el-col v-if="!fn">
                    <span class="amount">控股股东/控制人信息</span>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="选择展示内容：" prop="showctrl" class="required">
                        <el-radio-group v-model="acctInfo.showctrl" style="display: flex;margin-top: 10px">
                            <el-radio v-for="item in showCtrl" :key="item.id" :label="item.id">
                            {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.showctrl == '0'">
                    <el-col :span="12">
                        <el-form-item label="名称：" prop="majoritystakename" class="required">
                            <el-input v-model.trim="acctInfo.majoritystakename" placeholder="请输入控股股东名称" :maxlength="32" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控股股东类别：" prop="minvtp" class="required">
                            <el-select
                                v-model.trim="acctInfo.minvtp"
                                placeholder="请选择控股股东类别"
                                v-on:change="changeMinvtp()"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('150138') || []"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件类型：" prop="omcertificatetype" class="two-cols required">
                            <el-select
                                v-model.trim="acctInfo.omcertificatetype"
                                class="last-sel"
                                filterable
                                placeholder="请选择证件类型"
                            >
                                <el-option
                                    v-for="item in $cache.getDict(acctInfo.minvtp==='0' ? '130008' : '130007') "
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件号码：" prop="omcertificateno" class="required">
                            <el-input v-model.trim="acctInfo.omcertificateno" placeholder="请输入证件号码" :maxlength="18" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件有效期：" prop="holdingidvalidate" class="required">
                            <date-picker :key="1" :date="holdingDateSet" v-on:date-get="holdDateInterval" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话号码：" prop="shareholdertelno">
                            <div style="display: flex; width: 360px;justify-content: space-between">
                                <el-select
                                    v-model="acctInfo.shareholdertelnocycode"
                                    filterable
                                    placeholder="国家码"
                                    style="margin-right:5px"
                                >
                                    <el-option
                                        v-for="item in faxcycode"
                                        :key="item.subitem"
                                        :label="item.subitemname+' '+item.subitem"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-select
                                    v-if="acctInfo.shareholdertelnocycode == '86'"
                                    v-model="acctInfo.shareholdertelnoareacode"
                                    filterable
                                    placeholder="地区码"
                                    style="margin-right:5px"
                                >
                                    <el-option
                                        v-for="item in faxareacode"
                                        :key="item.subitem"
                                        :label="item.subitemname+' '+item.subitem"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-input v-model.trim="acctInfo.shareholdertelno" placeholder="电话号码" :maxlength="11" />
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电子邮箱：" prop="shareholderemail">
                            <el-input v-model.trim="acctInfo.shareholderemail" placeholder="请输入电子邮箱" :maxlength="128" />
                        </el-form-item>
                    </el-col>
                </el-col>

                <el-col v-if="acctInfo.showctrl == '1'">
                    <el-col :span="12">
                        <el-form-item label="名称：" prop="actualctrlname" class="required">
                            <el-input v-model.trim="acctInfo.actualctrlname" placeholder="请输入实际控制人名称" :maxlength="64" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控制人类别：" prop="actualctrltype" class="required">
                            <el-select
                                v-model.trim="acctInfo.actualctrltype"
                                filterable
                                placeholder="请选择实际控制人类别"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('150138')||[]"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件类型：" prop="actualctrlidtype" class="required">
                            <el-select
                                v-model.trim="acctInfo.actualctrlidtype"
                                filterable
                                placeholder="请选择证件类型"
                                v-on:change="checkCertNoAgain"
                            >
                                <el-option
                                    v-for="item in $cache.getDict(acctInfo.actualctrltype == '1' ? '110206' : '130008')||[]"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件号码：" prop="actualctrlidcode" class="required">
                            <el-input
                                v-model.trim="acctInfo.actualctrlidcode"
                                placeholder="请输入证件号码"
                                :maxlength="18"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件有效期：" prop="actualctrlvalidate" class="required">
                            <date-picker :key="2" :date="actualctrlDateSet" v-on:date-get="actualDateInterval" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话号码：" prop="actualctrltelno">
                            <div style="display: flex; width: 360px;justify-content: space-between">
                                <el-select
                                    v-model="acctInfo.actualctrltelnocycode"
                                    filterable
                                    placeholder="国家码"
                                    style="margin-right:5px"
                                >
                                    <el-option
                                        v-for="item in faxcycode"
                                        :key="item.subitem"
                                        :label="item.subitemname+' '+item.subitem"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-select
                                    v-if="acctInfo.actualctrltelnocycode == '86'"
                                    v-model="acctInfo.actualctrltelnoareacode"
                                    filterable
                                    placeholder="地区码"
                                    style="margin-right:5px"
                                >
                                    <el-option
                                        v-for="item in faxareacode"
                                        :key="item.subitem"
                                        :label="item.subitemname+' '+item.subitem"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-input v-model.trim="acctInfo.actualctrltelno" placeholder="电话号码" :maxlength="11" />
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电子邮箱：" prop="actualctrlemail">
                            <el-input v-model.trim="acctInfo.actualctrlemail" placeholder="请输入电子邮箱" :maxlength="128" />
                        </el-form-item>
                    </el-col>
                </el-col>
                <!--控股股东/控制人信息end-->

                <el-col v-if="!fn" style="padding-bottom:20px">
                    <div class="border"></div>
                </el-col>
                <el-col v-if="!fn">
                    <span class="amount">法人代表信息</span>
                </el-col>

                <el-col v-if="!fn" :span="24">
                    <el-form-item label="法人信息：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.instreprname }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件类型：">
                        <div v-if="!$util.isEmpty(acctInfo.instrepridtype)" class="text-con">
                            {{ acctInfo.instreprtype==0?$cache.getDict('130008',acctInfo.instrepridtype):$cache.getDict('130007',acctInfo.instrepridtype) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件号码：">
                        <div class="text-con">
                            {{ acctInfo.instrepridcode }}&emsp;
                            <el-button v-if="hadOCR && ocrOnOff" :disabled="ocrStatus" type="warning" size="mini" v-on:click="gotoUpdOcr">
                                {{ ocrBtnInfo }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="证件有效期：" prop="instreprvailddate">
                        <div class="text-con">
                            {{ $util.fmtDate(acctInfo.instreprvailddate) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="法人地址：" prop="instrepraddress">
                        <el-input v-model.trim="acctInfo.instrepraddress" placeholder="" :maxlength="128" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="法人邮编：" prop="instreprpostcode">
                        <el-input v-model.trim="acctInfo.instreprpostcode" placeholder="" :maxlength="6" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="24">
                    <el-form-item label="法人手机：" prop="instreprmobile">
                        <el-select
                            v-model="acctInfo.instreprmobilecycode"
                            placeholder="请选择国家码"
                            style="width:150px"
                        >
                            <el-option
                                v-for="item in instreprmobilecycode"
                                :key="item.subitem"
                                :label="item.subitemname+' '+item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-input v-model.trim="acctInfo.instreprmobile" placeholder="" :maxlength="11" style="width:240px"/>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="法人邮箱：" prop="instrepremail">
                        <el-input v-model.trim="acctInfo.instrepremail" placeholder="" :maxlength="14" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="法人职务：" prop="instreprposition">
                        <el-input v-model.trim="acctInfo.instreprposition" placeholder="" :maxlength="14" />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="法人生日：" prop="instreprbirthday">
                        <date-picker :date="birthSet" v-on:date-get="dateBirth" />
                    </el-form-item>
                </el-col>
                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="acctInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>

                <el-col :span="24" class="btn-group">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitInfo('acctInfo')">
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/common/datePicker.vue";
import countryCitySelect from "@/components/acctInfo/countryCitySelect.vue";
export default {
    name: "UserInfo",
    components: {
        datePicker,
        countryCitySelect
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            checkList: [],
            isPwdCheck: false,
            isSub: true,
            checkacctInfo: {},
            acctInfo: {},
            // 数据字典
            certTypes: [],
            annualincomes: [],
            delivertype: [],
            sex: [],
            vocationcode: [],
            educationlevel: [],
            province: [],
            country: [],
            isdigniaryorceo: [],
            beneficiarytype: [],
            faxcycode: [],
            faxareacode: [],
            instreprmobilecycode: [],
            delivertypes: [],
            deliverways: [],
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null,
                address: null
            },
            // 日期配置
            dateSet: { type: "3", max: "", dis: false },
            birthSet: { type: "1", min: "", dis: false },
            beneficiaryDateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
            beneficChangeFlag: true,
            isMobile: false, // 是否有手机号码
            rules: {
                annualincome: [
                    { required: true, message: "请选择年收入", trigger: "blur" }
                ],
                mobile: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                birthdate: [
                    { required: true, validator: this.$util.validateDate, trigger: "blur" }
                ],
                vailddate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                registeredcapital: [
                    { required: true, message: "请输入注册资本", trigger: "change" }
                ],
                deliverway: [
                    { validator: this.validateDeliverway, trigger: "change" }
                ],
                livingaddress: [
                    { required: true, message: "请输入地址", trigger: "change" },
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                postcode: [
                    { required: true, message: "请输入邮政编码", trigger: "change" },
                    { validator: this.validatePostCode, trigger: "blur" }
                ],
                vocationsupple: [
                    { required: true, validator: this.validateVocationsupple, trigger: "blur" }
                ],
                occupation: [
                    { required: true, message: "请选择职业", trigger: "change" }
                ],
                email: [
                    { validator: this.$util.validateEmail, trigger: "blur" }
                ],
                fax: [
                    { validator: this.validateFaxcycode, trigger: "blur" },
                    { validator: this.validateFaxareacode, trigger: "blur" }
                ],
                telno: [
                    { validator: this.$util.validateFaxNum, trigger: "blur" }
                ],
                isdigniaryorceo: [
                    { required: true, message: "请选择受益人类型", trigger: "change" }
                ],
                beneficiary: [
                    { validator: this.paramRequired, mes: "实际受益人", trigger: "change" }
                ],
                // beneficiary: [
                //     { validator: this.validateBeneficiary, trigger: "blur" }
                // ],
                beneficiarytype: [
                    { validator: this.validateBeneficiarytype, trigger: "change" }
                ],
                beneficiaryno: [
                    { validator: this.validateBeneficiaryno, trigger: "blur" }
                ],
                beneficiarydate: [
                    { validator: this.validateBeneficiarydate, trigger: "blur" }
                ],
                assetssource: [
                    { validator: this.validateAssetssource, trigger: "blur" }
                ],
                province: [
                    { validator: this.validateLocation, trigger: "change" }
                ],
                instreprpostcode: [
                    { validator: this.$util.validatePostCode, trigger: "blur" }
                ],
                instreprmobile: [
                    { validator: this.validateInstreprmobile, trigger: "blur" }
                ],
                instrepremail: [
                    { validator: this.$util.validateEmail, trigger: "blur" }
                ],
                // usefullife: [
                //     { required: true, message: "请输入注册地址", trigger: "change" }
                // ],
                // scopeofbusiness: [
                //     { required: true, message: "请输入经营范围", trigger: "change" }
                // ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ],
                delivertype: [
                    { required: true, message: "请选择对账单寄送周期", trigger: "blur" }
                ],
                instreprbirthday: [
                    { validator: this.validateInstreprbirthday, trigger: "change" }
                ],
                showctrl: [
                    { required: true, message: "请选择控股股东/控制人", trigger: "blur" }
                ],
                majoritystakename: [
                    {required: true, message: "请输入控股股东姓名", trigger: "blur"},
                    { validator: this.$util.validateName, trigger: "blur" }
                ],
                minvtp: [
                    {required: true, message: "请选择控股股东类别", trigger: "blur"},
                ],
                holdingidvalidate: [
                    {validator: this.validateMin, trigger: "blur"},
                    {required: true, message: "请选择日期", trigger: "blur"}
                ],
                omcertificatetype: [
                    {required: true, message: "请选择控股股东证件类型", trigger: "blur"}
                ],
                omcertificateno: [
                    {required: true, message: "请输入证件号码", trigger: "blur"},
                    {validator: this.checkMcCertNo, trigger: "blur"}
                ],
                shareholdertelno: [
                    {validator: this.validateHoldertelnocycode, trigger: "change"},
                    {validator: this.validateHoldertelnoareacode, trigger: "change"}
                ],
                actualctrltelno: [
                    {validator: this.validateCtrltelnocycode, trigger: "change"},
                    {validator: this.validateCtrltelnoareacode, trigger: "change"}
                ],
                shareholderemail: [
                    {validator: this.$util.validateEmail, trigger: "blur"}
                ],
                actualctrlname: [
                    {required: true, message: "请输入实际控制人姓名", trigger: "blur"},
                    { validator: this.$util.validateName, trigger: "blur" }
                ],
                actualctrltype: [
                    {required: true, message: "请选择实际控制人类别", trigger: "blur"}
                ],
                actualctrlvalidate: [
                    {validator: this.validateMin, trigger: "blur"},
                    {required: true, message: "请选择日期", trigger: "blur"}
                ],
                actualctrlidtype: [
                    {required: true, message: "请选择实际控制人证件类型", trigger: "blur"}
                ],
                actualctrlidcode: [
                    {required: true, message: "请输入证件号码", trigger: "blur"},
                    {validator: this.checkCtrCertNo, trigger: "blur"}
                ],
                actualctrlemail: [
                    {validator: this.$util.validateEmail, trigger: "blur"}
                ],
            },
            ocrOnOff: false, //ocr柜台开关
            ocrStatus: false, //ocr是否已经上传
            hadOCR: false,//ocr增值模块中台是否开启
            ocrBtnInfo: "更新证件信息",
            birthTemp: "",
            showCtrl: [{id: "0", name: "控股股东"}, {id: "1", name: "实际控制人"}],
            holdingDateSet: {type: "3", max: "", dis: false, val: "",text: "请选择证件有效期"}, // 控股股东证件有效期信息
            actualctrlDateSet: {type: "3", max: "", dis: false,val: "", text: "请选择证件有效期"} // 实际控制人证件有效期信息

        };
    },
    watch: {
        "acctInfo.delivertype" (val) {
            if (val === "1") {
                this.acctInfo.deliverway = "00000000";
            }
        },
        "acctInfo.occupation" (val) {
            if (val !== "06") {
                this.acctInfo.vocationsupple = "";
            }
        },
        "acctInfo.country" (val) {
            if (val !== "156") {
                this.acctInfo.province = "";
            }
        },
        "acctInfo.isdigniaryorceo" (val) {
            if (this.beneficChangeFlag) {
                this.beneficChangeFlag = !this.beneficChangeFlag;
                return false;
            }
            this.acctInfo.assetssource = "";
            this.acctInfo.beneficiary = "";
            this.acctInfo.beneficiarytype = "";
            this.acctInfo.beneficiaryno = "";
            this.acctInfo.beneficiarydate = "";
            this.$set(this.beneficiaryDateSet, "val", "");
            this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
        },
        "acctInfo.fax"(val){
            if(this.$util.isEmpty(val)){
                this.acctInfo.faxcycode = "";
                this.acctInfo.faxareacode = "";
            }
        },
        "acctInfo.faxcycode"(val){
            if(val !== "86"){
                this.acctInfo.telnoareacodeinput = this.acctInfo.faxareacode;
            }
        },
        "acctInfo.faxareacodeinput"(val){
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        "acctInfo.instreprmobile"(val) {
            this.mustNum(val, "instreprmobile");
        },
        acctInfo: {//深度监听，可监听到对象、数组的变化
            handler(val, oldVal){
                if(JSON.stringify(this.checkacctInfo) == JSON.stringify(this.acctInfo))
                    this.isSub = true;

                if(JSON.stringify(this.checkacctInfo) !== JSON.stringify(this.acctInfo))
                    this.isSub = false;
            },
            deep: true
        },
        'acctInfo.showctrl'(val){
            if(val==="0"){
                this.$refs.acctInfo.clearValidate("actualctrlname")
                this.$refs.acctInfo.clearValidate("actualctrltype")
                this.$refs.acctInfo.clearValidate("actualctrlidtype")
                this.$refs.acctInfo.clearValidate("actualctrlidcode")
                this.$refs.acctInfo.clearValidate("actualctrlvalidate")
                this.$refs.acctInfo.clearValidate("actualctrltelnocycode")
                this.$refs.acctInfo.clearValidate("actualctrltelnoareacode")
                this.$refs.acctInfo.clearValidate("actualctrltelno")
                this.$refs.acctInfo.clearValidate("actualctrlemail")
            }else{
                this.$refs.acctInfo.clearValidate("majoritystakename")
                this.$refs.acctInfo.clearValidate("minvtp")
                this.$refs.acctInfo.clearValidate("omcertificatetype")
                this.$refs.acctInfo.clearValidate("omcertificateno")
                this.$refs.acctInfo.clearValidate("holdingidvalidate")
                this.$refs.acctInfo.clearValidate("shareholdertelnocycode")
                this.$refs.acctInfo.clearValidate("shareholdertelnoareacode")
                this.$refs.acctInfo.clearValidate("shareholdertelno")
                this.$refs.acctInfo.clearValidate("shareholderemail")
            }

        }
    },
    created () {
        this.hadOCR = this.$cache.getStatus("OCR") == "1" ? true : false;
        this.birthTemp = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.birthSet.max = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.birthSet.min = this.$util.fmtDate("19000101");
        // 重新提取最小日期
        const conf = this.$util.getConfig().const;
        const info = this.$cache.getUser();
        info.showctrl = !this.$util.isEmpty(info.majoritystakename) ? "0" : "1";
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.$set(this.beneficiaryDateSet, "val", format(info.beneficiarydate,"YYYY-MM-DD"));
        this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
        this.isPwdCheck = this.$cache.getPwdCheck("B1");
        const _x = {};
        for (let item in info) {
            _x[item] = info[item].trim();
        }
        if (_x.mobile && _x.mobile != "00") {
            this.isMobile = true;
        }
        // 国籍默认中国
        if (!_x.country) {
            _x.country = "156";
        }
        if(this.$route.query){
            _x.custname = this.$route.query.custname || _x.custname;
            _x.certificateno = this.$route.query.certificateno || _x.certificateno;
            _x.vailddate = this.$route.query.vailddate || _x.vailddate;
            _x.birthdate = this.$route.query.birthdate || _x.birthdate;
            if(_x.certTypeText === "身份证" && this.$route.query.certificateno){
                _x.sex = (this.$route.query.certificateno.substr(16,1) % 2).toString();
            }
            const _this = this;
            if(this.$route.query.birthdate){
                const _date = this.$util.getBeginDate(format(new Date(),"YYYYMMDD"),18,true);
                if(Number(this.$route.query.birthdate) >= Number(_date)){
                    _this.$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                        confirmButtonText: "确定",
                        type: "warning",
                        callback: action => {
                            _this.$router.push({name: "orginfo"});
                        }
                    }).then(() => {
                        return false;
                    }).catch(() => {
                        return false;
                    });
                }
            }
        }
        if (_x.beneficiary !== "本机构") {
            _x.beneficiaryText = _x.beneficiary;
            _x.beneficiary = _x.beneficiary ? "其他" : "本机构";
        }
        this.acctInfo = Object.assign({}, this.acctInfo, _x);
        if(!this.$util.isEmpty(this.acctInfo.actualctrlvalidate)){
            this.actualctrlDateSet.val = this.$util.fmtDate(this.acctInfo.actualctrlvalidate);
        }
        this.actualctrlDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        if(!this.$util.isEmpty(this.acctInfo.holdingidvalidate)){
            this.holdingDateSet.val = this.$util.fmtDate(this.acctInfo.holdingidvalidate);
        }
        this.holdingDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.checkacctInfo = Object.assign({}, this.checkacctInfo, _x);
        this.dateSet.val = this.$util.fmtDate(this.acctInfo.vailddate);
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        if(this.acctInfo.instreprbirthday) {
            this.birthSet.val = this.$util.fmtDate(this.acctInfo.instreprbirthday);
        }
        // this.birthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        // :TODO: 测试瑞年
        // this.birthSet.max = this.$util.fmtDate(
        //     format(new Date(), "YYYYMMDD") - 180000
        // );

        this.annualincomes = this.$cache.getDict("150061");
        this.certTypes = this.$cache.getDict("130007");
        this.delivertype = this.$cache.getDict("110046");
        this.sex = this.$cache.getDict("110059").reverse();
        this.vocationcode = this.$cache.getDict("100011");
        this.deliverways = this.$cache.getDict("100013");
        this.educationlevel = this.$cache.getDict("100014");
        this.faxcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.faxareacode = this.$cache.getDict("150137");
        this.instreprmobilecycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.delivertypes = this.$cache.getDict("110046");
        const _country = this.$cache.getDict("110049");
        let _y = [];
        let _z = [];
        for(let i in _country){
            if(_country[i].subitem === "156" || _country[i].subitem === "158" || _country[i].subitem === "344" || _country[i].subitem === "446"){
                _z.push(_country[i]);
                continue;
            }
            _y.push(_country[i]);
        }
        this.country = _z.concat(_y);
        // this.isdigniaryorceo = this.$cache.getDict("120126");
        this.isdigniaryorceo = this.$cache.getDict("120179");
        this.beneficiarytype = this.$cache.getDict("130007");
        this.province = this.$cache.getDict("120122");
        if(this.hadOCR){
            this.getOcrOpenStatus();
        }
        this.initAddress();
    },
    methods: {
        initAddress(){
            this.livingAddressObj["country"] = this.acctInfo["livingcountry"];
            this.livingAddressObj["province"] = this.acctInfo["livingaddressprovince"];
            this.livingAddressObj["city"] = this.acctInfo["livingaddresscity"];
            this.livingAddressObj["county"] = this.acctInfo["livingaddresscounty"];
        },
        getAddress(data){
            this.acctInfo.address = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        setAddress() {
            this.acctInfo["livingcountry"] = this.livingAddressObj["country"];
            this.acctInfo["livingaddressprovince"] = this.livingAddressObj["province"];
            this.acctInfo["livingaddresscity"] = this.livingAddressObj["city"];
            this.acctInfo["livingaddresscounty"] = this.livingAddressObj["county"];
        },
        checkLivingaddrInfo(){
            let hasLivingAddrInfo = true;
            if(this.acctInfo.livingcountry === "CN" ){
                hasLivingAddrInfo = !!this.acctInfo.livingaddressprovince && !!this.acctInfo.address && !!this.acctInfo.livingaddresscity;
            }else{
                hasLivingAddrInfo = !!this.acctInfo.address;
            }
            if(!hasLivingAddrInfo || this.$util.isEmpty(this.acctInfo.livingcountry)){
                this.$alert("请完善通讯地址(国家/地区-省-市-县)信息！","提示");
                return false;
            }
            return true;
        },
        paramRequired (rule, value, callback) {
            if ((rule.field === "actualctrlname" && this.acctInfo.actualctrlname !== "本机构") || (rule.field === "beneficiary" && this.acctInfo.beneficiary !== "本机构") || (rule.field === "credit" && this.acctInfo.creditrecord !== "良好")) {
                this.$util.validateGeneral(rule, this.acctInfo[rule.field + "Text"], callback, rule.mes);
            } else {
                if (value.trim() !== "") {
                    this.$util.validateGeneral(rule, value, callback, rule.mes);
                } else {
                    callback();
                }
            }
        },
        dateInterval (val) {
            this.acctInfo.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("vailddate");
        },
        holdDateInterval(val) {
            this.$set(this.acctInfo,"holdingidvalidate",val !== null ? val.replace(/-/g, "") : "");
            if(!this.$util.isEmpty(this.acctInfo.holdingidvalidate)){
                this.holdingDateSet.val = this.$util.fmtDate(this.acctInfo.holdingidvalidate);
            }
            this.$refs.acctInfo.validateField("holdingidvalidate");
        },
        actualDateInterval(val) {
            this.$set(this.acctInfo,"actualctrlvalidate",val !== null ? val.replace(/-/g, "") : "");
            if(!this.$util.isEmpty(this.acctInfo.actualctrlvalidate)){
                this.actualctrlDateSet.val = this.$util.fmtDate(this.acctInfo.actualctrlvalidate);
            }
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        dateBirth (val) {
            this.acctInfo.instreprbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        beneficiaryDateInterval (val) {
            this.acctInfo.beneficiarydate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("beneficiarydate");
        },
        validateAddress (rule, value, callback) {
            if (this.acctInfo.deliverway === "1" && !value) {
                callback(new Error("请输入联系地址"));
            } else {
                callback();
            }
        },
        validateLocation(rule, value, callback){
            if(this.acctInfo.country === "156"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择省份"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateInstreprmobile(rule, value, callback){
            if (this.$util.isEmpty(this.acctInfo.instreprmobilecycode) && value !== "") {
                callback(new Error("请选择法人手机国家码"));
            }else{
                callback();
            }
        },
        validateAssetssource(rule, value, callback){
            if(this.acctInfo.isdigniaryorceo === "1"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入资金来源"));
                }
            }
            if(!this.$util.isEmpty(value)){
                this.$util.validateGeneral(rule, value, callback,"资金来源");
            }else{
                callback();
            }
        },
        validateBeneficiary(rule, value, callback){
            if(this.acctInfo.isdigniaryorceo === "2"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入受益人姓名"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback){
            if(this.acctInfo.isdigniaryorceo === "2"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择受益人证件类型"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback){
            if(this.acctInfo.isdigniaryorceo === "2"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请输入受益人证件号码"));
                }else{
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.beneficiarytype);
                }
            }else{
                callback();
            }
        },
        validateBeneficiarydate(rule, value, callback){
            if(this.acctInfo.isdigniaryorceo === "2"){
                if(this.$util.isEmpty(value)){
                    callback(new Error("请选择受益人证件有效期"));
                }else{
                    callback();
                }
            }else{
                callback();
            }
        },
        validatePostCode (rule, value, callback) {
            if (this.acctInfo.deliverway === "1" || value !== "") {
                this.$util.validatePostCode(rule, value, callback);
            } else {
                callback();
            }
        },
        validateVocationsupple (rule, value, callback) {
            if (this.acctInfo.occupation === "06" && !value) {
                callback(new Error("请输入职业补充信息"));
            } else {
                callback();
            }
        },
        validateDeliverway (rule, value, callback) {
            if (value === "" || value === "00000000") {
                callback(new Error("对账单寄送方式"));
            } else {
                callback();
            }
        },
        validateEmail (rule, value, callback) {
            if (this.acctInfo.deliverway === "3" || value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        },
        validateInstreprbirthday (rule, value, callback) {
            if (value !== "" && Number(value) >= Number(this.birthTemp)) {
                callback(new Error("出生日期未满18岁"));
            } else {
                callback();
            }
        },
        validateFaxcycode (rule, value, callback) {
            if (value !== "" && !this.acctInfo.faxcycode) {
                callback(new Error("请选择传真国家码"));
            } else {
                callback();
            }
        },
        validateFaxareacode (rule, value, callback) {
            if ( value !== "" && !this.acctInfo.faxareacode) {
                callback(new Error("请选择传真地区码"));
            } else {
                callback();
            }
        },
        validateHoldertelnocycode(rule, value, callback) {
            if (!this.$util.isEmpty(value) && !this.acctInfo.shareholdertelnocycode) {
                callback(new Error("请选择国家码"));
            } else {
                callback();
            }
        },
        validateHoldertelnoareacode(rule, value, callback) {
            if (!this.$util.isEmpty(value) && this.acctInfo.shareholdertelnocycode == "86" && !this.acctInfo.shareholdertelnoareacode) {
                callback(new Error("请选择地区码"));
            } else {
                callback();
            }
        },
        validateCtrltelnocycode(rule, value, callback) {
            if (!this.$util.isEmpty(value) && !this.acctInfo.actualctrltelnocycode) {
                callback(new Error("请选择国家码"));
            } else {
                callback();
            }
        },
        validateCtrltelnoareacode(rule, value, callback) {
            if (!this.$util.isEmpty(value) && this.acctInfo.actualctrltelnocycode == "86" && !this.acctInfo.actualctrltelnoareacode) {
                callback(new Error("请选择地区码"));
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.checkacctInfo.pwd = _this.acctInfo.pwd;
            _this.setAddress();
            if(!this.checkLivingaddrInfo()){
                return;
            }
            if(JSON.stringify(_this.checkacctInfo) == JSON.stringify(_this.acctInfo)) {
                _this.$message({
                    type: "info",
                    message: "表单数据未改变，请勿重复提交"
                });
                return;
            }
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if(this.acctInfo.birthdate){
                        const _date = this.$util.getBeginDate(format(new Date(),"YYYYMMDD"),18,true);
                        if(Number(this.acctInfo.birthdate) >= Number(_date)){
                            _this.$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: action => {
                                    _this.$router.push({name: "orginfo"});
                                }
                            }).then(() => {
                                return false;
                            }).catch(() => {
                                return false;
                            });
                            return;
                        }
                    }
                    let _obj = _this.$util.getObjParam(_this.acctInfo, "vailddate,country,occupation,delivertype,deliverway,sex,educationlevel,postcode,email,telno,delivertype,fax,address,remark,birthdate,isdigniaryorceo,province,assetssource,beneficiary,beneficiarytype,beneficiaryno,beneficiarydate");
                    _obj.location = _obj.country === "156" ? this.$cache.getDict("120122",_obj.province) : this.$cache.getDict("110049",_obj.country);
                    _obj.belongregion = _obj.country === "156" ? "中国" : "外国";
                    if (!_this.isMobile) {
                        _obj.mobile = _this.acctInfo.mobile;
                    }
                    _obj.tradepwd = this.$util.enc(_this.acctInfo.pwd);
                    if(_obj.occupation === "06"){
                        _obj.vocationsupple = _this.acctInfo.vocationsupple;
                    }
                    _this.$util.request("acct/common/riskycust", {certificatetype: _this.acctInfo.certificatetype, invtp: "1"}, "GET").then(res => {
                        if (res.data) {
                            if (res.data[0].flag === "1") {
                                if (_this.fn) {
                                    _this.$alert("账号为风险客户，请联系客服进行修改操作!", "信息提示", {
                                        confirmButtonText: "确定",
                                        type: "warning",
                                        callback: action => {
                                            this.$router.push({ name: "modifyinfo" });
                                        }
                                    }).then(() => {
                                        return false;
                                    }).catch(() => {
                                        return false;
                                    });
                                    return false;
                                }
                                _this.$message.warning("账号为风险客户，请联系客服进行修改操作!");
                                return false;
                            } else {
                                if (_this.acctInfo.beneficiary !== "本机构") {
                                    _this.acctInfo.beneficiary = _this.acctInfo.beneficiaryText;
                                }
                                _this.acctInfo.tradepwd = this.$util.enc(_this.acctInfo.pwd);
                                delete _this.acctInfo.pwd;
                                delete _this.acctInfo.certificateno;
                                // 整理控股股东/控制人信息
                                _this.handleShowctrl();
                                _this.$util.request("acct/orgcust/profile", _this.acctInfo, "PUT").then(res => {
                                    if (res.data) {
                                        let _x = Object.assign({}, _this.acctInfo, {pwd: ""});
                                        _x.creditrecord = "";
                                        _x.certexpired = "0";
                                        _this.$store.dispatch("setInfo", _x).then(() => {
                                            _this.$cache.refreshUser();
                                            _this.$message({
                                                type: "success",
                                                message: "个人信息已更新成功" + (_this.fn ? "" : "，3秒后回到个人信息页面"),
                                                onClose: function () {
                                                    if (_this.fn) { _this.$emit("fn-back", true); } else {
                                                        _this.$router.push({ name: "orginfo" });
                                                    }
                                                }
                                            });
                                        });

                                    }
                                });
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 整理控股股东/控制人信息
        handleShowctrl(){
            if(this.acctInfo.showctrl === "0"){
                this.acctInfo.actualctrlname = "";
                this.acctInfo.actualctrltype = "";
                this.acctInfo.actualctrlidtype = "";
                this.acctInfo.actualctrlidcode = "";
                this.acctInfo.actualctrlvalidate = "";
                this.acctInfo.actualctrltelnocycode = "";
                this.acctInfo.actualctrltelnoareacode = "";
                this.acctInfo.actualctrltelno = "";
                this.acctInfo.actualctrlemail = "";
            }
            if(this.acctInfo.showctrl === "1"){
                this.acctInfo.majoritystakename = "";
                this.acctInfo.minvtp = "";
                this.acctInfo.omcertificatetype = "";
                this.acctInfo.omcertificateno = "";
                this.acctInfo.holdingidvalidate = "";
                this.acctInfo.shareholdertelnocycode = "";
                this.acctInfo.shareholdertelnoareacode = "";
                this.acctInfo.shareholdertelno = "";
                this.acctInfo.shareholderemail = "";
            }
        },
        checkCtrCertNo(rule, value, callback) {
            if (this.acctInfo.actualctrltype === "1") {
                this.$util.validateCertNo(rule, value, callback, this.acctInfo.actualctrlidtype, true);
            }
            else {
                this.$util.validateCertNo(rule, value, callback, this.acctInfo.actualctrlidtype, false);
            }
        },
        // 再次校验证件号码
        checkCertNoAgain () {
            this.$refs.acctInfo.validateField("certNo");
        },
        checkMcCertNo(rule, value, callback) {
            if (this.acctInfo.minvtp === "1") {
                this.$util.validateCertNo(rule, value, callback, this.acctInfo.omcertificatetype, true);
            }
            else {
                this.$util.validateCertNo(rule, value, callback, this.acctInfo.omcertificatetype, false);
            }
        },
        getOcrOpenStatus () {
            const _this = this;
            const _x = this.$util.src("/acct/ocr/check",{},true);
            const _data = {};
            this.$req({
                method: "GET",
                url: _x,
                timeout: 20000,
                data: _data
            }).then(res => {
                if (res.code === "0000000") {
                    if (res.record[0][0].isOpenOcr == "1") {
                        _this.ocrOnOff = true;
                        if ( _this.acctInfo.certificatetype == "0") {
                            _this.dateSet.dis = true;
                            _this.birthSet.dis = true;
                            const info = _this.$cache.getUser();
                            /* _this.dateSet.dis = true; */
                            let _val = "";
                            if(_this.$route.query){
                                _val = _this.$route.query.vailddate;
                            }
                            let vailddate = _val || info.vailddate;
                            if(Number(format(new Date(),"YYYYMMDD")) > Number(vailddate) && _this.$cache.getUser().usertype !== "2"){
                                this.$alert("证件有效期已过期，请重新上传证件", "信息提示", {
                                    confirmButtonText: "重新上传",
                                    callback: action => {
                                        _this.$router.push({ name: "ocrinfoupd", query: { certificatetype: _this.acctInfo.certificatetype } });
                                    }
                                });
                                return;
                            }
                        }
                        if (res.record[0][0].ocrUploadFlag != "0") {
                            _this.ocrStatus = true;
                            _this.ocrBtnInfo = "已上传";
                        }
                    }
                } else {
                    _this.$message.error(res.msg);
                }
            }).catch(() => { });
        },
        gotoUpdOcr () {
            const _this = this;
            this.$router.push({ name: "ocrinfoupd", query: { certificatetype: _this.acctInfo.certificatetype } });
        },
        validateMin (rule, value, callback) {
            if(this.$util.isEmpty(value))callback()
            if (Number(value) < Number(format(new Date(),"YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        mustNum (val, param) {
            const _x = this.$util.filterNum(val);
            this.$set(this.acctInfo, param, _x);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-user-info {
    padding-bottom: 30px;
    .acct-box {
        padding: 20px 10px;
        .amount {
            display: block;
            color: $text-color2;
            line-height: 26px;
            font-size: $f18;
          }
        .el-form-item {
            margin-bottom: 18px;
            &.is-required .el-form-item__label:before {
                content: "";
            }
            &.required .el-form-item__label:before {
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
        .btn-group {
            margin-top: 20px;
            text-align: center;
            .el-button + .el-button {
                margin-left: 30px;
            }
        }
        .el-select {
            width: 70%;
            .el-input {
                width: 100%;
            }
        }
        .el-input,
        .el-textarea {
            width: 70%;
            .el-input__inner {
                height: 38px;
                line-height: 36px;
            }
        }
        .vailddate-box {
            .el-select {
                width: 40%;
                .el-input {
                    width: 100%;
                }
            }
            .el-input,
            .el-textarea {
                width: 40%;
            }
            .comp-date-picker {
                width: 100%;
                .el-input {
                    width: 40%;
                }
            }
        }
        .el-form-item__label {
            padding: 0;
            line-height: 38px;
        }
    }
}
</style>
